export function convertFromDate(date) {
    // Converts data from date format to string
    if (date === null) {
        return null
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export function convertToDate(date) {
    // Parses string to date data
    if (date === null) {
        return null
    }
    const newDate = new Date(Date.parse(date))
    return newDate

}
